import { Injectable } from '@angular/core';
import { UserGroupService } from '@core/services/user-group.service';
import { ComponentStore } from '@ngrx/component-store';
import { EMPTY, MonoTypeOperatorFunction, Observable, pipe } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { IUserGroup } from '../../../core/interfaces/user-group.interface';

interface IUserGroupSelectState {
  userGroup: IUserGroup | null;
  loading: boolean;
  error: string | null;
}

const initialState: IUserGroupSelectState = {
  error: null,
  loading: false,
  userGroup: null,
};

@Injectable()
export class UserGroupSelectStore extends ComponentStore<IUserGroupSelectState> {
  public readonly userGroup$ = this.selectSignal((state: IUserGroupSelectState) => state.userGroup);
  public readonly loading$ = this.selectSignal((state: IUserGroupSelectState) => state.loading);
  public readonly error$ = this.selectSignal((state: IUserGroupSelectState) => state.error);

  private readonly handleError = (errorMessage: string): MonoTypeOperatorFunction<unknown> =>
    pipe(
      catchError(() => {
        this.patchState({
          error: errorMessage,
          loading: false,
        });

        return EMPTY;
      }),
    );

  public readonly switchUserGroup = this.effect((trigger$: Observable<string>) => {
    return trigger$.pipe(
      tap(() => this.patchState({ error: null, loading: true })),
      switchMap((userGroupId) =>
        this.userGroupService.switchUserGroup(userGroupId).pipe(
          tap((userGroup: IUserGroup) => {
            this.patchState({ userGroup });
          }),
          this.handleError('Failed to switch user group'),
        ),
      ),
    );
  });

  constructor(private readonly userGroupService: UserGroupService) {
    super(initialState);
  }
}
